module.exports = __webpack_public_path__ + "img/12.76d33acb.jpg";